import * as directory from './directory';
import * as recipe from './recipe';

/**
 * `.directory` handles all the data about the integrations, triggers, actions, closures, conditions and tokens that
 * are available in Automator and Automator Pro. It mostly uses `UncannyAutomator._integrations`. It doesn't contain
 * the data, but it offers methods to easily access it. Don't add any code that changes `UncannyAutomator._recipe` here.
 */
UncannyAutomator._core.directory = directory;

/**
 * `.recipe` offers methods to modify and get data from the `UncannyAutomator._recipe` object. For example, this has
 * the methods that perform the REST calls to update the recipe items
 */
UncannyAutomator._core.recipe = recipe;